module.exports = {
      id: "vikatanplay-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatanplay",
      toString: function () {
        return this.url;
      }
    }